const DAY_MS = 86_400_000;

/** The account's `created_at` from the game server, mirrored by `syncProfileFromServer`. */
export const PLAYER_CREATED_AT_KEY = 'player_created_at';

/** Whole days since a date (ISO string or ms), or null when there is none. */
export function daysSince( date: string | number | null | undefined, now: number = Date.now() ): number | null
{
  if ( date === null || date === undefined || date === '' ) return null;

  const t = typeof date === 'number' ? date : new Date( date ).getTime();
  if ( !Number.isFinite( t ) || t <= 0 ) return null;

  return Math.max( 0, Math.floor( ( now - t ) / DAY_MS ) );
}

/**
 * Days in game of the current player: from the account's server registration, so the profile
 * and the leaderboard agree and a reinstall does not reset it. Before the first login has
 * stored it, falls back to this device's install date.
 */
export function ownDaysInGame( install_date?: number ): number | null
{
  let created_at: string | null = null;
  try { created_at = localStorage.getItem( PLAYER_CREATED_AT_KEY ); } catch { /* storage blocked */ }
  return daysSince( created_at ) ?? daysSince( install_date );
}
